import React from 'react';

export function ProofBar() {
  const partners = [
    "A BOSTON SAAS STARTUP",
    "A LONDON DIGITAL AGENCY",
    "A TEXAS REAL ESTATE INVESTMENT FIRM",
    "A SHOPIFY FULFILLMENT COMPANY",
    "A CHICAGO HEALTHCARE STAFFING AGENCY",
    "A SYDNEY E-COMMERCE BRAND"
  ];

  return (
    <div className="w-full border-y border-hairline py-12 overflow-hidden bg-paper">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk text-center">
        <p className="font-mono text-caption text-graphite uppercase tracking-[0.12em] whitespace-nowrap overflow-x-auto no-scrollbar">
          TRUSTED BY FOUNDERS AT &nbsp;·&nbsp; {partners.join(' · ')}
        </p>
      </div>
    </div>
  );
}